import { usePlaybackIsPlaying } from '@app/core/playback/hooks/usePlayback';
import { useStreamSegmentsRange } from '@app/modules/logger/screens/stream/hooks/segments/useStreamSegmentsQuery';
import { useStreamSelection } from '@app/modules/logger/screens/stream/stores/useStreamSelection';

/**
 * Hook that determines if the current selection can be played.
 * Returns true only if:
 * - Both selection markers (tsA and tsB) exist
 * - The selection is within the loaded stream range
 * - Audio is not currently playing
 */
export function useCanPlaySelection(): boolean {
  const isPlaying = usePlaybackIsPlaying();
  const { selection, selectionRange } = useStreamSelection();
  const streamRange = useStreamSegmentsRange();

  // Check if both selection markers exist
  const hasCompleteSelection = !!selection.tsA && !!selection.tsB;

  // Check if selection is within the loaded stream range
  const isSelectionWithinStreamRange =
    hasCompleteSelection &&
    selectionRange.from >= streamRange.from &&
    selectionRange.to <= streamRange.to;

  return !isPlaying && isSelectionWithinStreamRange;
}
